import React from 'react';
import { Database, Calculator } from 'lucide-react';

const QuantitySourceToggle = ({ 
  value, 
  onChange, 
  disabled = false,
  className = ""
}) => {
  const handleToggle = (newValue) => {
    if (disabled) return;
    // Always fire onChange — parent decides whether a re-click on the
    // already-active option should open an editor (e.g. Flächen) or no-op.
    onChange(newValue);
  };

  return (
    <div className={`flex items-center space-x-4 ${className}`}>
      <span className="text-sm font-medium text-gray-700">Datenquelle:</span>
      
      <div className="flex bg-gray-100 rounded-lg p-1">
        {/* Delivery Notes Option */}
        <button
          type="button"
          onClick={() => handleToggle('deliveryNotes')}
          disabled={disabled}
          className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
            value === 'deliveryNotes'
              ? 'bg-white text-blue-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-800'
          } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
        >
          <Database className="h-4 w-4" />
          <span>Lieferscheine</span>
        </button>

        {/* Calculated Layers Option */}
        <button
          type="button"
          onClick={() => handleToggle('calculatedLayers')}
          disabled={disabled}
          className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
            value === 'calculatedLayers'
              ? 'bg-white text-green-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-800'
          } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
        >
          <Calculator className="h-4 w-4" />
          <span>Flächen</span>
        </button>
      </div>

      {/* Status Indicator */}
      <div className="flex items-center space-x-1">
        <div className={`w-2 h-2 rounded-full ${
          value === 'deliveryNotes' ? 'bg-blue-500' : 'bg-green-500'
        }`} />
        <span className="text-xs text-gray-500">
          {value === 'deliveryNotes' ? 'Lieferschein Mengen' : 'Berechnete Mengen'}
        </span>
      </div>
    </div>
  );
};

export default QuantitySourceToggle;
